import React, { Component } from 'react';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Label } from 'reactstrap';
import CSVIcon from '../Images/csv-ico.png';
import EmployeesFile from '../Resources/Example of Employees.csv';
import Checkbox from '@material-ui/core/Checkbox';
import EmployeeService from '../Services/EmployeeService/employeeService';
import CustomField from '../Services/CustomField/CustomField';
import { css } from 'react-emotion';
import Radio from '@material-ui/core/Radio';
import { Redirect } from 'react-router-dom';
import ReactTooltip from 'react-tooltip'
// First way to import
import { ClipLoader } from 'react-spinners';
var base64 = require('base-64');

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class EmployeesImportFile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            uploadKey: 'default',
            EmployeeList: { pennding: false, value: [] },
            EmployeeUpList: { pennding: false, value: [] },
            CustomFieldData: [],
            CustomFieldListSelect: [],
            HeadersList: [],
            DataAll: [],
            CustomFieldResult: [],
            error: null,
            checkboxOptions: [],
            CompanyCode: "",
            Selected: false,
            loading: false,
            AddButton: "",
            selectedValue: '2',
            Headers: false,
            HEmployeeID: false,
            HEmployeeFName: false,
            HEmployeeMName: false,
            HEmployeeLName: false,
            HEmployeeLocationCode: false,
            HEmployeeDepartmentCode: false,
            HEmployeeStatus: false,
            HEmployeeType: false,
            HEmployeeBirthday: false,
            HEmployeeHiredDate: false,
            HEmployeeInactiveDate: false,
            HEmployeeTerminateDate: false,
            HEmployeeEmail: false,
            HEmployeePhone: false,
            HEmployeeStreet: false,
            HEmployeeCity: false,
            HEmployeeZip: false,
            HEmployeeState: false,
            HEmployeeCountry: false,
            HEmployeePositionName: false,
            HEmployeeEmergencyContact: false,
            HEmployeeContactPhone: false,
            HEmployeeMobile: false,
            HEmployeeRate: false,
            HEmployeePayClass: false,
            HEmployeeSalaryType: false,
            HEmployeePersonalID: false,
            UploadFileName: "Choose File",
            tooltipOpen: false,
            isAutenticated: true
        };
        this.handleData = this.handleData.bind(this);
        this.GetCustomListHeader = this.GetCustomListHeader.bind(this);
        this.GetCustomListValue = this.GetCustomListValue.bind(this);
        this.SelectedAll = this.SelectedAll.bind(this);
        this.onChange = this.onChange.bind(this);
        this.toggle = this.toggle.bind(this);
        this.RenderCustomField = this.RenderCustomField.bind(this);
    }
    toggle() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }
    componentWillMount() {
        this.getCustomField();
    }
    handleHEmployeeAll(e, item) {

        var ValueItem = e.value;
        //var LabelItem = e.label;
        var Data = Object.assign([], this.state.DataAll);
        Data[item].label = ValueItem;
        //Data[item].label = LabelItem;
        this.setState({
            DataAll: Data
        }, () => console.log());
    }
    handleData(e) {
        var uploadedFile = e.target.files[0];
        var name = e.target.files[0] ? e.target.files[0].name : "Choose File";
        var extFile = e.target.files[0].name.split('.').pop();

        this.setState({
            uploadKey: e.target.files[0]['lastModified'] + e.target.files[0]['size'] + e.target.files[0]['name'],
            EmployeeUpList: { pennding: true, value: [] },
            HeadersList: [],
            Headers: false
        });
        if (uploadedFile) {
            if (extFile.toUpperCase() !== "CSV") {
                toast.error("File has to be a .CSV!", {
                    className: {
                        opacity: 0.8
                    }
                });
                return false;
            }

            let reader = new FileReader();
            reader.onload = (progressEvent) => {
                // let target = progressEvent.target; 
                // let result = target.result;               
                var base64result = reader.result.split(',')[1];
                var encoded = base64.decode(base64result);
                var data = encoded.split('\n');
                var DataList = [];
                var DataAll = [];
                var CustomFieldListSelect = [];

                data.forEach(element => {
                    element = element.trimRight("\n");
                    DataList.push(element.split(','));
                });
                var CustomFieldList = this.state.CustomFieldData;
                //var DataConcat = DataList[0].concat(CustomFieldList);

                CustomFieldList.forEach((item2) => {
                    //DataAll[item2] = null;   
                    DataAll.push({ key: item2, value: null });
                    CustomFieldListSelect.push({ value: item2, label: item2 });
                });
                var EmployeeID = "";
                var FirstName = "";
                var LastName = "";
                var Status = "";
                var CompanyLocation = "";
                var DepartmentCode = "";
                var EmployeeType = "";
                var MiddleName = "";
                var Email = "";
                var Mobile = "";
                var DateofBirthday = "";
                var InactiveDate = "";
                var HiredDate = "";
                var TerminatedDate = "";
                var PersonalID = "";
                var State = "";
                var City = "";
                var Address = "";
                var HZip = "";
                var ContactPhone = "";
                var SalaryType = "";
                var HourlyRate = "";
                var Country = "";
                var PayClass = "";
                var Phone = "";
                var EmergencyContact = "";
                var PositionName = "";
                DataList[0].forEach(function (element) {

                    if (element.replace(/\s/g, "").toUpperCase() === "EMPLOYEEID") {

                        EmployeeID = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "FIRSTNAME") {

                        FirstName = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "LASTNAME") {

                        LastName = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "STATUS") {

                        Status = element;
                    }
                    else if (element.replace(/\s/g, "").toUpperCase() === "LOCATIONCODE") {

                        CompanyLocation = element;
                    }
                    else if (element.replace(/\s/g, "").toUpperCase() === "DEPARTMENTCODE") {

                        DepartmentCode = element;
                    }
                    else if (element.replace(/\s/g, "").toUpperCase() === "EMPLOYEETYPE") {

                        EmployeeType = element;
                    }
                    else if (element.replace(/\s/g, "").toUpperCase() === "MIDDLENAME") {

                        MiddleName = element;
                    }
                    else if (element.replace(/\s/g, "").toUpperCase() === "EMAIL") {

                        Email = element;
                    }
                    else if (element.replace(/\s/g, "").toUpperCase() === "MOBILE") {

                        Mobile = element;
                    }
                    else if (element.replace(/\s/g, "").toUpperCase() === "BIRTHDAY(YYYY-MM-DD)") {

                        DateofBirthday = element;
                    }
                    else if (element.replace(/\s/g, "").toUpperCase() === "INACTIVEDATE(YYYY-MM-DD)") {

                        InactiveDate = element;
                    }
                    else if (element.replace(/\s/g, "").toUpperCase() === "HIREDDATE(YYYY-MM-DD)") {

                        HiredDate = element;
                    }
                    else if (element.replace(/\s/g, "").toUpperCase() === "TERMINATEDATE(YYYY-MM-DD)") {

                        TerminatedDate = element;
                    }
                    else if (element.replace(/\s/g, "").toUpperCase() === "PERSONALID") {

                        PersonalID = element;
                    }
                    else if (element.replace(/\s/g, "").toUpperCase() === "STATE") {

                        State = element;
                    }
                    else if (element.replace(/\s/g, "").toUpperCase() === "CITY") {

                        City = element;
                    }
                    else if (element.replace(/\s/g, "").toUpperCase() === "STREET") {

                        Address = element;
                    }
                    else if (element.replace(/\s/g, "").toUpperCase() === "ZIP") {

                        HZip = element;
                    }
                    else if (element.replace(/\s/g, "").toUpperCase() === "CONTACTPHONE") {

                        ContactPhone = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "EMERGENCYCONTACT") {

                        EmergencyContact = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "RATE") {

                        HourlyRate = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "PHONE") {

                        Phone = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "PAYCLASS") {

                        PayClass = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "POSITIONNAME") {

                        PositionName = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "COUNTRY") {

                        Country = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "SALARYTYPE") {

                        SalaryType = element;
                    }


                });


                this.setState({
                    EmployeeUpList: { pennding: true, value: DataList },
                    HeadersList: DataList[0],
                    DataAll: DataAll,
                    CustomFieldListSelect: CustomFieldListSelect,
                    Headers: true,
                    UploadFileName: name,
                    HEmployeeID: { label: EmployeeID, value: EmployeeID },
                    HEmployeeFName: { label: FirstName, value: FirstName },
                    HEmployeeMName: { label: MiddleName, value: MiddleName },
                    HEmployeeLName: { label: LastName, value: LastName },
                    HEmployeeLocationCode: { label: CompanyLocation, value: CompanyLocation },
                    HEmployeeDepartmentCode: { label: DepartmentCode, value: DepartmentCode },
                    HEmployeeStatus: { label: Status, value: Status },
                    HEmployeeType: { label: EmployeeType, value: EmployeeType },
                    HEmployeeBirthday: { label: DateofBirthday, value: DateofBirthday },
                    HEmployeeHiredDate: { label: HiredDate, value: HiredDate },
                    HEmployeeInactiveDate: { label: InactiveDate, value: InactiveDate },
                    HEmployeeTerminateDate: { label: TerminatedDate, value: TerminatedDate },
                    HEmployeeEmail: { label: Email, value: Email },
                    HEmployeePhone: { label: Phone, value: Phone },
                    HEmployeeStreet: { label: Address, value: Address },
                    HEmployeeCity: { label: City, value: City },
                    HEmployeeZip: { label: HZip, value: HZip },
                    HEmployeeState: { label: State, value: State },
                    HEmployeeCountry: { label: Country, value: Country },
                    HEmployeePositionName: { label: PositionName, value: PositionName },
                    HEmployeeEmergencyContact: { label: EmergencyContact, value: EmergencyContact },
                    HEmployeeContactPhone: { label: ContactPhone, value: ContactPhone },
                    HEmployeeMobile: { label: Mobile, value: Mobile },
                    HEmployeeRate: { label: HourlyRate, value: HourlyRate },
                    HEmployeePayClass: { label: PayClass, value: PayClass },
                    HEmployeeSalaryType: { label: SalaryType, value: SalaryType },
                    HEmployeePersonalID: { label: PersonalID, value: PersonalID },
                });
            };
            reader.readAsDataURL(uploadedFile);
        } else {
            this.setState({
                EmployeeUpList: { pennding: true, value: [] },
                HeadersList: [],
                Headers: true,
                UploadFileName: "Choose File"
            });
        }
    }
    getCustomField() {
        var email = sessionStorage.getItem('email');
        var CompanyCode = this.props.CompanyCode;
        var that = this;

        var CustomFieldPromise = CustomField.getCustomField(CompanyCode, email);
        CustomFieldPromise.then(function (data) {
            if (data.statusText === "OK") {
                that.setState({
                    CustomFieldData: data.data,
                });
            }
        }).catch((error) => {
            that.setState({
                CCustomFieldData: [],
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    handleHEmployeeID = event => {
        this.setState({
            HEmployeeID: event
        });
    }
    handleHEmployeeFName = event => {
        this.setState({
            HEmployeeFName: event
        });
    }
    handleHEmployeeMName = event => {
        this.setState({
            HEmployeeMName: event
        });
    }
    handleHEmployeeLName = event => {
        this.setState({
            HEmployeeLName: event
        });
    }
    handleHEmployeeLocationCode = event => {
        this.setState({
            HEmployeeLocationCode: event
        });
    }
    handleHEmployeeDepartmentCode = event => {
        this.setState({
            HEmployeeDepartmentCode: event
        });
    }
    handleHEmployeeStatus = event => {
        this.setState({
            HEmployeeStatus: event
        });
    }
    handleHEmployeeType = event => {
        this.setState({
            HEmployeeType: event
        });
    }
    handleHEmployeeBirthday = event => {
        this.setState({
            HEmployeeBirthday: event
        });
    }
    handleHEmployeeHiredDate = event => {
        this.setState({
            HEmployeeHiredDate: event
        });
    }
    handleHEmployeeInactiveDate = event => {
        this.setState({
            HEmployeeInactiveDate: event
        });
    }
    handleHEmployeeTerminateDate = event => {
        this.setState({
            HEmployeeTerminateDate: event
        });
    }
    handleHEmployeeEmail = event => {
        this.setState({
            HEmployeeEmail: event
        });
    }
    handleHEmployeePhone = event => {
        this.setState({
            HEmployeePhone: event
        });
    }
    handleHEmployeeStreet = event => {
        this.setState({
            HEmployeeStreet: event
        });
    }
    handleHEmployeeCity = event => {
        this.setState({
            HEmployeeCity: event
        });
    }
    handleHEmployeeZip = event => {
        this.setState({
            HEmployeeZip: event
        });
    }
    handleHEmployeeState = event => {
        this.setState({
            HEmployeeState: event
        });
    }
    handleHEmployeeCountry = event => {
        this.setState({
            HEmployeeCountry: event
        });
    }
    handleHEmployeePositionName = event => {
        this.setState({
            HEmployeePositionName: event
        });
    }
    handleHEmployeeEmergencyContact = event => {
        this.setState({
            HEmployeeEmergencyContact: event
        });
    }
    handleHEmployeeContactPhone = event => {
        this.setState({
            HEmployeeContactPhone: event
        });
    }
    handleHEmployeeMobile = event => {
        this.setState({
            HEmployeeMobile: event
        });
    }
    handleHEmployeeHourlyRate = event => {
        this.setState({
            HEmployeeRate: event
        });
    }
    handleHEmployeePayClass = event => {
        this.setState({
            HEmployeePayClass: event
        });
    }
    handleHEmployeeSalaryType = event => {
        this.setState({
            HEmployeeSalaryType: event
        });
    }
    handleHEmployeePersonalID = event => {
        this.setState({
            HEmployeePersonalID: event
        });
    }
    handleChange = event => {

        this.setState({
            selectedValue: event.target.value,
            EmployeeList: { pennding: false, value: [] }
        });
    }
    UploadLocationList(e) {
        e.preventDefault();

        var ActionType = this.state.selectedValue;
        var DataList = this.state.EmployeeUpList.value;
        var HeaderListist = this.state.HeadersList;
        var HeaderEmployeeID = this.state.HEmployeeID.value;
        var HeaderEmployeeFName = this.state.HEmployeeFName.value;
        var HeaderEmployeeMName = this.state.HEmployeeMName.value;
        var HeaderEmployeeLName = this.state.HEmployeeLName.value;
        var HeaderEmployeeLocationCode = this.state.HEmployeeLocationCode.value;
        var HeaderEmployeeDepartmentCode = this.state.HEmployeeDepartmentCode.value;
        var HeaderEmployeeStatus = this.state.HEmployeeStatus.value;
        var HeaderEmployeeType = this.state.HEmployeeType.value;
        var HeaderEmployeeBirthday = this.state.HEmployeeBirthday.value;
        var HeaderEmployeeHiredDate = this.state.HEmployeeHiredDate.value;
        var HeaderEmployeeInactiveDate = this.state.HEmployeeInactiveDate.value;
        var HeaderEmployeeTerminateDate = this.state.HEmployeeTerminateDate.value;
        var HeaderEmployeeEmail = this.state.HEmployeeEmail.value;
        var HeaderEmployeePhone = this.state.HEmployeePhone.value;
        var HeaderEmployeeStreet = this.state.HEmployeeStreet.value;
        var HeaderEmployeeCity = this.state.HEmployeeCity.value;
        var HeaderEmployeeZip = this.state.HEmployeeZip.value;
        var HeaderEmployeeState = this.state.HEmployeeState.value;
        var HeaderEmployeeCountry = this.state.HEmployeeCountry.value;
        var HeaderEmployeePositionName = this.state.HEmployeePositionName.value;
        var HeaderEmployeeEmergencyContact = this.state.HEmployeeEmergencyContact.value;
        var HeaderEmployeeContactPhone = this.state.HEmployeeContactPhone.value;
        var HeaderEmployeeMobile = this.state.HEmployeeMobile.value;
        var HeaderEmployeeRate = this.state.HEmployeeRate.value;
        var HeaderEmployeePayClass = this.state.HEmployeePayClass.value;
        var HeaderEmployeeSalaryType = this.state.HEmployeeSalaryType.value;
        var HeaderEmployeePersonalID = this.state.HEmployeePersonalID.value;
        var CustomFieldData = this.state.CustomFieldData;
        var Result = [];
        var CustomFieldResult = [];

        var positionEmployeeID = HeaderListist.indexOf(HeaderEmployeeID);
        var positionEmployeeFName = HeaderListist.indexOf(HeaderEmployeeFName);
        var positionEmployeeMName = HeaderListist.indexOf(HeaderEmployeeMName);
        var positionEmployeeLName = HeaderListist.indexOf(HeaderEmployeeLName);
        var positionEmployeeLocationCode = HeaderListist.indexOf(HeaderEmployeeLocationCode);
        var positionEmployeeDepartmentCode = HeaderListist.indexOf(HeaderEmployeeDepartmentCode);
        var positionEmployeeStatus = HeaderListist.indexOf(HeaderEmployeeStatus);
        var positionEmployeeType = HeaderListist.indexOf(HeaderEmployeeType);
        var positionEmployeeBirthday = HeaderListist.indexOf(HeaderEmployeeBirthday);
        var positionEmployeeHiredDate = HeaderListist.indexOf(HeaderEmployeeHiredDate);
        var positionEmployeeInactiveDate = HeaderListist.indexOf(HeaderEmployeeInactiveDate);
        var positionEmployeeTerminateDate = HeaderListist.indexOf(HeaderEmployeeTerminateDate);
        var positionEmployeeEmail = HeaderListist.indexOf(HeaderEmployeeEmail);
        var positionEmployeePhone = HeaderListist.indexOf(HeaderEmployeePhone);
        var positionEmployeeStreet = HeaderListist.indexOf(HeaderEmployeeStreet);
        var positionEmployeeCity = HeaderListist.indexOf(HeaderEmployeeCity);
        var positionEmployeeZip = HeaderListist.indexOf(HeaderEmployeeZip);
        var positionEmployeeState = HeaderListist.indexOf(HeaderEmployeeState);
        var positionEmployeeCountry = HeaderListist.indexOf(HeaderEmployeeCountry);
        var positionEmployeePositionName = HeaderListist.indexOf(HeaderEmployeePositionName);
        var positionEmployeeEmergencyContact = HeaderListist.indexOf(HeaderEmployeeEmergencyContact);
        var positionEmployeeContactPhone = HeaderListist.indexOf(HeaderEmployeeContactPhone);
        var positionEmployeeMobile = HeaderListist.indexOf(HeaderEmployeeMobile);
        var positionEmployeeRate = HeaderListist.indexOf(HeaderEmployeeRate);
        var positionEmployeePayClass = HeaderListist.indexOf(HeaderEmployeePayClass);
        var positionEmployeeSalaryType = HeaderListist.indexOf(HeaderEmployeeSalaryType);
        var positionEmployeePersonalID = HeaderListist.indexOf(HeaderEmployeePersonalID);

        if (positionEmployeeID === -1) {
            toast.error("ID field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (positionEmployeeFName === -1) {
            toast.error("Name field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (positionEmployeeLName === -1) {
            toast.error("Last Name field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (positionEmployeeLocationCode === -1) {
            toast.error("Location Code field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (positionEmployeeDepartmentCode === -1) {
            toast.error("Department Code field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (positionEmployeeStatus === -1) {
            toast.error("Status field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (positionEmployeeType === -1) {
            toast.error("Employee Type field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        var MName = "";
        var Birthday = "";
        var HiredDate = "";
        var InactiveDate = "";
        var TerminateDate = "";
        var Email = "";
        var Phone = "";
        var PStreet = "";
        var City = "";
        var ZipCode = "";
        var State = "";
        var Country = "";
        var PositionName = "";
        var EmergencyContact = "";
        var ContactPhone = "";
        var Mobile = "";
        var Rate = "";
        var PPayclass = "";
        var SalaryType = "";
        var PersonalID = "";
        for (var i = 1; i < DataList.length; i++) {

            if (DataList[i] !== "") {

                if (positionEmployeeMName === -1)
                    MName = "";
                else
                    MName = DataList[i][positionEmployeeMName];

                if (positionEmployeeBirthday === -1)
                    Birthday = "";
                else
                    Birthday = DataList[i][positionEmployeeBirthday];

                if (positionEmployeeHiredDate === -1)
                    HiredDate = "";
                else
                    HiredDate = DataList[i][positionEmployeeHiredDate];

                if (positionEmployeeInactiveDate === -1)
                    InactiveDate = "";
                else
                    InactiveDate = DataList[i][positionEmployeeInactiveDate];

                if (positionEmployeeTerminateDate === -1)
                    TerminateDate = "";
                else
                    TerminateDate = DataList[i][positionEmployeeTerminateDate];

                if (positionEmployeeEmail === -1)
                    Email = "";
                else
                    Email = DataList[i][positionEmployeeEmail];

                if (positionEmployeePhone === -1)
                    Phone = "";
                else
                    Phone = DataList[i][positionEmployeePhone];

                if (positionEmployeeStreet === -1)
                    PStreet = "";
                else
                    PStreet = DataList[i][positionEmployeeStreet];

                if (positionEmployeeCity === -1)
                    City = "";
                else
                    City = DataList[i][positionEmployeeCity];

                if (positionEmployeeZip === -1)
                    ZipCode = "";
                else
                    ZipCode = DataList[i][positionEmployeeZip];

                if (positionEmployeeState === -1)
                    State = "";
                else
                    State = DataList[i][positionEmployeeState];

                if (positionEmployeeCountry === -1)
                    Country = "";
                else
                    Country = DataList[i][positionEmployeeCountry];

                if (positionEmployeePositionName === -1)
                    PositionName = "";
                else
                    PositionName = DataList[i][positionEmployeePositionName];

                if (positionEmployeeEmergencyContact === -1)
                    EmergencyContact = "";
                else
                    EmergencyContact = DataList[i][positionEmployeeEmergencyContact];

                if (positionEmployeeContactPhone === -1)
                    ContactPhone = "";
                else
                    ContactPhone = DataList[i][positionEmployeeContactPhone];

                if (positionEmployeeMobile === -1)
                    Mobile = "";
                else
                    Mobile = DataList[i][positionEmployeeMobile];

                if (positionEmployeeRate === -1)
                    Rate = "";
                else
                    Rate = DataList[i][positionEmployeeRate];

                if (positionEmployeePayClass === -1)
                    PPayclass = "";
                else
                    PPayclass = DataList[i][positionEmployeePayClass];

                if (positionEmployeeSalaryType === -1)
                    SalaryType = "";
                else
                    SalaryType = DataList[i][positionEmployeeSalaryType];

                if (positionEmployeePersonalID === -1)
                    PersonalID = "";
                else
                    PersonalID = DataList[i][positionEmployeePersonalID];


                Result.push({
                    USER_ID: DataList[i][positionEmployeeID], FIRST_NAME: DataList[i][positionEmployeeFName], MIDDLE_NAME: MName,
                    LAST_NAME: DataList[i][positionEmployeeLName], EMAIL_ADDRESS: Email, PHONE_NUMBER: Phone,
                    COMPANY_LOCATION_CODE: DataList[i][positionEmployeeLocationCode], DEPARTMENT_CODE: DataList[i][positionEmployeeDepartmentCode],
                    BIRTHDAY: Birthday, STATUS: DataList[i][positionEmployeeStatus], HIRED_DATE: HiredDate, INACTIVE_DATE: InactiveDate,
                    TERMINATED_DATE: TerminateDate, EMPLOYEE_TYPE: DataList[i][positionEmployeeType], ADDRESS_LINE1: PStreet,
                    ADDRESS_CITY: City, ADDRESS_ZIP_CODE: ZipCode, ADDRESS_STATE: State, ADDRESS_COUNTRY: Country,
                    POSITION_NAME: PositionName, EMERGENCY_CONTACT: EmergencyContact, CONTACT_PHONE: ContactPhone,
                    MOBILE: DataList[i][Mobile], RATE: Rate, PAY_CLASS: PPayclass, SALARY_TYPE: SalaryType, PERSONAL_ID: PersonalID
                });
                var name_exist = "";
                var name_key = "";
                var PositionCF = "";
                var ListValues = this.state.DataAll;
                if (name_exist !== DataList[i][positionEmployeeID]) {
                    // eslint-disable-next-line
                    CustomFieldData.forEach((item2, index) => {//drops a warning in the eslint [no-loop-func] becaus is creating functions inside a for loop. search for line 668
                        var temp = ListValues.find(c => c.key === item2);
                        if (temp.value !== null && temp.value !== undefined && temp.value !== "") {
                            var positionCustomField = HeaderListist.indexOf(temp.value.value);
                            // var name = DataList[i][positionEmployeeID];
                            if (positionCustomField === -1)
                                PositionCF = "";
                            else
                                PositionCF = DataList[i][positionCustomField];
                            if (temp.key !== name_key) {

                                CustomFieldResult.push({
                                    NAME: temp.key,
                                    VALUE: PositionCF,
                                    USER_ID: DataList[i][positionEmployeeID],
                                });
                                name_key = temp.key;
                            }
                        } else {
                            CustomFieldResult.push({
                                NAME: temp.key,
                                VALUE: "",
                                USER_ID: DataList[i][positionEmployeeID],
                            });
                            name_key = temp.key;
                        }

                    });
                    name_exist = DataList[i][positionEmployeeID];
                }

            }
        }


        this.setState({ CustomFieldResult: CustomFieldResult })

        if (DataList === "" || DataList === null || DataList === undefined || DataList.length === 0) {
            toast.error("You must to select a File!", {
                className: {
                    opacity: 0.8
                }
            });
        } else {
            if (this.props.CompanyCode && DataList) {
                this.setState({
                    EmployeeList: { pennding: true, value: [] }
                });

                var ListResult = EmployeeService.getEmployeeListResult(this.props.CompanyCode, Result, CustomFieldResult, ActionType);
                var that = this;
                ListResult.then(function (data) {
                    // console.log(data)      
                    if (data.statusText === "OK") {
                        that.setState({
                            EmployeeList: { pennding: false, value: data.data },
                            checkboxOptions: []
                        });
                    }
                }).catch((error) => {

                    that.setState({
                        EmployeeList: { pennding: false, value: [] },
                        checkboxOptions: []
                    });
                    if (error.response) {
                        if (error && error.response && error.response.data.Message === "500") {
                            toast.error("Error Data Base(Error: 500)", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data === "NoDB") {
                            toast.error("Company Code dosen't exist!", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data === "NotReseller") {
                            toast.error("This User does not have permission!", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data.Message === "400") {
                            toast.error("API Error for Reseller", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error.response.status === 401) {
                            sessionStorage.setItem("user", '');
                            sessionStorage.setItem("token", '');
                            sessionStorage.setItem("rol", '');
                            sessionStorage.setItem("email", '');
                            sessionStorage.clear();
                            this.setState({ isAutenticated: false },
                                () => {
                                    this.forceUpdate();
                                })
                        }
                    } else {
                        toast.error("Code Error", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    }
                });
            }
        }
    }
    onChange(e, code) {

        const options = this.state.checkboxOptions
        let index

        if (!options.find(x => x === code)) {
            options.push(code)
        } else {
            index = options.indexOf(code)
            options.splice(index, 1)
        }
        this.setState({ checkboxOptions: options }, console.log())
    }
    SelectedAll(e) {
        if (e.target.checked) {
            let optionChecked = [];
            this.state.EmployeeList.value.forEach(l => {
                if (l.AVAILABLE)
                    optionChecked.push(l.USER_ID);
            })
            this.setState({ checkboxOptions: optionChecked })
        } else {
            this.setState({ checkboxOptions: [] })
        }

    }
    SaveEmployeeList(e) {
        e.preventDefault();

        var CheckboxList = this.state.checkboxOptions;
        var email = sessionStorage.getItem('email');
        var ActionType = this.state.selectedValue;
        var CustomFieldList = this.state.CustomFieldResult;
        var result = [];
        var that = this;

        that.setState({
            loading: true,
            AddButton: "disabled"
        });
        if (CheckboxList.length === 0 || ActionType === "" || ActionType === undefined || ActionType === null) {
            toast.error("You must to select a User and Option Rows!", {
                className: {
                    opacity: 0.8
                }
            });
            that.setState({
                loading: false,
                AddButton: ""
            });
        } else {
            CheckboxList.forEach(l => {
                var department = this.state.EmployeeList.value.find(x => x.USER_ID === l);
                result.push(department);
            })
            var MaxUsers = this.props.MaxUsers;
            var EmplyeeTotal = result.length;
            if (EmplyeeTotal > MaxUsers) {
                that.setState({
                    loading: false,
                    AddButton: ""
                });
                toast.error("Can not exceed the limit of users for the license of this company!", {
                    className: {
                        opacity: 0.8
                    }
                });
                return false;
            }
            var DataResult = EmployeeService.SaveEmployee(this.props.CompanyCode, result, CustomFieldList, ActionType, email);
            DataResult.then(function (data) {
                if (data.data === "OK") {
                    that.setState({
                        loading: false,
                        EmployeeList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: ""
                    });
                    toast.success("User Saved!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (data.data === "InUse") {
                    that.setState({
                        loading: false,
                        EmployeeList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.error("Department Code in Use!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (data.statusText === "No") {
                    that.setState({
                        loading: false,
                        EmployeeList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.error("No Saved!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (data.statusText === "AuditError") {
                    that.setState({
                        loading: false,
                        EmployeeList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.error("No Saved!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                }
            }).catch((error) => {
                that.setState({
                    loading: false,
                    EmployeeList: { pennding: false, value: [] },
                    checkboxOptions: [],
                    AddButton: "",
                    CompanyCode: "",
                });
                if (error.response) {
                    if (error && error.response && error.response.data.Message === "500") {
                        toast.error("Error Data Base(Error: 500)", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data === "NoDB") {
                        toast.error("Company Code dosen't exist!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data === "NotReseller") {
                        toast.error("This User does not have permission!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data.Message === "400") {
                        toast.error("API Error for Reseller", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error.response.status === 401) {
                        sessionStorage.setItem("user", '');
                        sessionStorage.setItem("token", '');
                        sessionStorage.setItem("rol", '');
                        sessionStorage.setItem("email", '');
                        sessionStorage.clear();
                        this.setState({ isAutenticated: false },
                            () => {
                                this.forceUpdate();
                            })
                    }
                } else {
                    toast.error("Code Error", {
                        className: {
                            opacity: 0.8
                        }
                    });
                }
            });
        }
    }
    changeName(e) {
        //alert(e.target.value)
        var str = e.target.value;
        var res = str.substring(12)
        var extention = res.split('.').pop();

        if (extention.toUpperCase() === "CSV") {
            this.setState({
                FileName: res
            });
        } else {
            this.setState({
                FileName: "CHOOSE A FILE",
                EmployeeUpList: { pennding: false, value: [] },
            });
            toast.error("File Error!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        return true;
    }

    renderToolTip(item) {
        var List = item.split(',');
        var ResultToolTip = List.map((item, index) => {
            return <li className="row" key={index}> {item}</li>;
        })
        return ResultToolTip;
    }
    RenderCustomField() {

        // var HeaderCustomField = this.state.CustomFieldList;
        //console.log(this.state.DataAll[0])
        let optionItemsHeaders = this.state.HeadersList.map((item, index) => {
            return { value: item, label: item }
        });

        var ResultCustomField = this.state.DataAll.map((item, index) => {

            return <div className="col-2" key={index}>
                <div className="form-group">
                    <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >{item.key + " (CustomField)"}</label>
                    <Select
                        value={this.state.DataAll[index].value}
                        //onChange={(e)=>this.handleHEmployeeAll(e, index)}
                        onChange={e => {

                            //var ValueItem = e.value;
                            var Data = Object.assign([], this.state.DataAll);
                            Data[index].value = e;
                            this.setState({
                                DataAll: Data
                            }, () => console.log());
                        }}
                        options={optionItemsHeaders}
                        styles={{ width: "10px" }}
                    />
                </div>
            </div>;
        })

        return ResultCustomField;
    }


    GetCustomListHeader() {
        let listData = this.state.CustomFieldData;

        return listData.map((item, index) => {
            //return {value: item, label: item}
            return <th scope="col" key={index}>{item + " (CustomField)"}</th>
        }
        );
    }

    GetCustomListValue(id) {
        let CustomFieldData = this.state.CustomFieldResult;
        let result = [];
        CustomFieldData.forEach((item, index) => {
            if (id + "" === item.USER_ID + "") {
                result.push(<th scope="col" key={index}>{item.VALUE}</th>)
            }
        })

        return result;
    }

    render() {

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'} />)
        }

        let optionItemsHeaders = this.state.HeadersList.map((item, index) => {
            return { value: item, label: item }
        });

        return (
            <div>
                <div className="card Logs"><ToastContainer hideProgressBar />
                    <div className="card-body">
                        <div className="row">
                            <div className="col-2">
                                <h4><span className="badge badge-info">Employees</span></h4>
                            </div>
                            <div className="col-2 offset-10">
                                <Label for="exampleFile" style={{ 'fontWeight': 'bold' }}>Download Sample</Label>
                                <a href={EmployeesFile} download="Example of Employees.CSV"><img src={CSVIcon} title="NotImage" alt="" width='40px' /></a>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3 offset-2">
                                {
                                    this.props.CompanyCode
                                    &&
                                    <div className="upload-btn-wrapper" key={this.state.uploadKey}>
                                        <button style={{ 'width': '100%', 'backgroundColor': '#00C851', 'marginLeft': '0px' }} onClick={(e) => this.fileInput.click(e)} className="btn btn-primary">{this.state.UploadFileName}</button>
                                        <input ref={input => this.fileInput = input} type="file" name="myfile" style={{ 'display': 'none' }} onChange={(event) => { this.handleData(event) }} />
                                    </div>
                                }
                            </div>
                            <div className="col-3">
                                {
                                    this.props.CompanyCode
                                    &&
                                    <div >
                                        <label>Delete Rows in Table</label>
                                        <Radio
                                            checked={this.state.selectedValue === '1'}
                                            onChange={this.handleChange}
                                            value="1"
                                            name="radio-button-demo"
                                            aria-label="A"
                                            color="primary"
                                        />
                                    </div>
                                }

                            </div>
                            <div className="col-3">
                                {
                                    this.props.CompanyCode
                                    &&
                                    <div >
                                        <label>Appends Rows in Table</label>
                                        <Radio
                                            checked={this.state.selectedValue === '2'}
                                            onChange={this.handleChange}
                                            value="2"
                                            name="radio-button-demo"
                                            aria-label="B"
                                            color="primary"
                                        />
                                    </div>
                                }
                            </div>

                        </div>
                        <br /> <br />
                        {
                            this.state.Headers
                            &&
                            <div className="row">
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >User ID(<span style={{ color: 'red' }}>*</span>):</label>
                                        <Select
                                            value={this.state.HEmployeeID}
                                            onChange={this.handleHEmployeeID}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >First Name(<span style={{ color: 'red' }}>*</span>):</label>
                                        <Select
                                            value={this.state.HEmployeeFName}
                                            onChange={this.handleHEmployeeFName}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Last Name(<span style={{ color: 'red' }}>*</span>)</label>
                                        <Select
                                            value={this.state.HEmployeeLName}
                                            onChange={this.handleHEmployeeLName}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Status(<span style={{ color: 'red' }}>*</span>)</label>
                                        <Select
                                            value={this.state.HEmployeeStatus}
                                            onChange={this.handleHEmployeeStatus}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Company Location Code(<span style={{ color: 'red' }}>*</span>)</label>
                                        <Select
                                            value={this.state.HEmployeeLocationCode}
                                            onChange={this.handleHEmployeeLocationCode}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Department Code(<span style={{ color: 'red' }}>*</span>)</label>
                                        <Select
                                            value={this.state.HEmployeeDepartmentCode}
                                            onChange={this.handleHEmployeeDepartmentCode}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Employee Type(<span style={{ color: 'red' }}>*</span>)</label>
                                        <Select
                                            value={this.state.HEmployeeType}
                                            onChange={this.handleHEmployeeType}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Middle Name</label>
                                        <Select
                                            value={this.state.HEmployeeMName}
                                            onChange={this.handleHEmployeeMName}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Email</label>
                                        <Select
                                            value={this.state.HEmployeeEmail}
                                            onChange={this.handleHEmployeeEmail}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Phone</label>
                                        <Select
                                            value={this.state.HEmployeePhone}
                                            onChange={this.handleHEmployeePhone}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Birthday(<span>YYYY-MM-DD</span>)</label>
                                        <Select
                                            value={this.state.HEmployeeBirthday}
                                            onChange={this.handleHEmployeeBirthday}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Hired Date(<span>YYYY-MM-DD</span>)</label>
                                        <Select
                                            value={this.state.HEmployeeHiredDate}
                                            onChange={this.handleHEmployeeHiredDate}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Inactive Date(<span>YYYY-MM-DD</span>)</label>
                                        <Select
                                            value={this.state.HEmployeeInactiveDate}
                                            onChange={this.handleHEmployeeInactiveDate}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Terminate Date(<span>YYYY-MM-DD</span>)</label>
                                        <Select
                                            value={this.state.HEmployeeTerminateDate}
                                            onChange={this.handleHEmployeeTerminateDate}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Street</label>
                                        <Select
                                            value={this.state.HEmployeeStreet}
                                            onChange={this.handleHEmployeeStreet}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >City</label>
                                        <Select
                                            value={this.state.HEmployeeCity}
                                            onChange={this.handleHEmployeeCity}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Zip</label>
                                        <Select
                                            value={this.state.HEmployeeZip}
                                            onChange={this.handleHEmployeeZip}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >State</label>
                                        <Select
                                            value={this.state.HEmployeeState}
                                            onChange={this.handleHEmployeeState}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Country</label>
                                        <Select
                                            value={this.state.HEmployeeCountry}
                                            onChange={this.handleHEmployeeCountry}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Position Name</label>
                                        <Select
                                            value={this.state.HEmployeePositionName}
                                            onChange={this.handleHEmployeePositionName}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Emergency Contact</label>
                                        <Select
                                            value={this.state.HEmployeeEmergencyContact}
                                            onChange={this.handleHEmployeeEmergencyContact}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Contact Phone</label>
                                        <Select
                                            value={this.state.HEmployeeContactPhone}
                                            onChange={this.handleHEmployeeContactPhone}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Rate</label>
                                        <Select
                                            value={this.state.HEmployeeRate}
                                            onChange={this.handleHEmployeeHourlyRate}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Pay Class</label>
                                        <Select
                                            value={this.state.HEmployeePayClass}
                                            onChange={this.handleHEmployeePayClass}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Salary Type</label>
                                        <Select
                                            value={this.state.HEmployeeSalaryType}
                                            onChange={this.handleHEmployeeSalaryType}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Personal ID</label>
                                        <Select
                                            value={this.state.HEmployeePersonalID}
                                            onChange={this.handleHEmployeePersonalID}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                            </div>

                        }

                        {
                            this.state.Headers && this.state.CustomFieldData
                            &&
                            <div className="row">
                                {
                                    this.RenderCustomField()
                                }
                            </div>

                        }
                        <div className="row">
                            {
                                this.state.Headers
                                &&
                                <div className="col-2 offset-md-10">
                                    <button className="btn btn-info" onClick={(e) => { this.UploadLocationList(e) }} >PREVIEW</button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                {
                    (this.state.EmployeeList.pennding
                        && <span className="loader"></span>)
                    ||
                    (this.state.EmployeeList.value.length > 0
                        && <div className="card Logs">
                            <div className="card-body" style={{ 'overflow': 'auto' }}>
                                <div className="row" style={{ 'height': '350px', 'overflow': 'auto', 'width': '3500px' }}>
                                    <table className="table table-hover table-striped table-lg table-responsive" >
                                        <thead>
                                            <tr>
                                                <th scope="col">
                                                    <Checkbox
                                                        style={{ width: 25, height: 25 }}
                                                        // checked={this.state.Selected}
                                                        onChange={this.SelectedAll}
                                                        //value={this.state.checkboxOptions}
                                                        color="primary"
                                                    />
                                                </th>
                                                <th scope="col">ID</th>
                                                <th scope="col">First Name</th>
                                                <th scope="col">Middle Name</th>
                                                <th scope="col">Last Name</th>
                                                <th scope="col">Location Code</th>
                                                <th scope="col">Department Code</th>
                                                <th scope="col">Status</th>
                                                <th scope="col">Employee Type</th>
                                                <th scope="col">Pay Class</th>
                                                <th scope="col">Birthday</th>
                                                <th scope="col">Hired Date</th>
                                                <th scope="col">Inactive Date</th>
                                                <th scope="col">Terminate Date</th>
                                                <th scope="col">Email</th>
                                                <th scope="col">Phone</th>
                                                <th scope="col">Street</th>
                                                <th scope="col">City</th>
                                                <th scope="col">Zip</th>
                                                <th scope="col">State</th>
                                                <th scope="col">Country</th>
                                                <th scope="col">Position Name</th>
                                                <th scope="col">Emergency Con.</th>
                                                <th scope="col">Con. Phone</th>
                                                <th scope="col">Mobile</th>
                                                <th scope="col">Salary Type</th>
                                                <th scope="col">Rate</th>
                                                <th scope="col">Personal ID</th>
                                                {this.GetCustomListHeader()}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                (this.state.EmployeeList.pennding
                                                    && <tr><td colSpan="7"><span className="loader"></span></td></tr>)
                                                || this.state.EmployeeList.value.map((item, index) => {

                                                    return <tr key={index}>
                                                        <td>
                                                            {
                                                                (item.AVAILABLE
                                                                    &&
                                                                    <Checkbox
                                                                        style={{ width: 25, height: 25 }}
                                                                        checked={this.state.checkboxOptions.find(x => x === item.USER_ID) !== undefined}
                                                                        onChange={(e) => this.onChange(e, item.USER_ID)}
                                                                        value={item.USER_ID}
                                                                        color="primary"
                                                                    />)
                                                                ||
                                                                <div className="badge badge-danger" id={"ToolTip" + item.USER_ID}>
                                                                    <a data-tip data-for={"global" + item.USER_ID}>Error </a>
                                                                    <ReactTooltip id={"global" + item.USER_ID} aria-haspopup='true' role={"role" + item.USER_ID} type="error" place="right" className="extraClass">
                                                                        <ul>
                                                                            {
                                                                                this.renderToolTip(item.AVAILABLE_MSG)
                                                                            }
                                                                        </ul>
                                                                    </ReactTooltip>
                                                                </div>
                                                            }
                                                        </td>
                                                        <td>{item.USER_ID}</td>
                                                        <td>{item.FIRST_NAME}</td>
                                                        <td>{item.MIDDLE_NAME}</td>
                                                        <td>{item.LAST_NAME}</td>
                                                        <td>{item.COMPANY_LOCATION_CODE}</td>
                                                        <td>{item.DEPARTMENT_CODE}</td>
                                                        <td>{item.STATUS}</td>
                                                        <td>{item.EMPLOYEE_TYPE}</td>
                                                        <td>{item.PAY_CLASS}</td>
                                                        <td>{item.BIRTHDAY}</td>
                                                        <td>{item.HIRED_DATE}</td>
                                                        <td>{item.INACTIVE_DATE}</td>
                                                        <td>{item.TERMINATED_DATE}</td>
                                                        <td>{item.EMAIL_ADDRESS}</td>
                                                        <td>{item.PHONE_NUMBER}</td>
                                                        <td>{item.ADDRESS_LINE1}</td>
                                                        <td>{item.ADDRESS_CITY}</td>
                                                        <td>{item.ADDRESS_ZIP_CODE}</td>
                                                        <td>{item.ADDRESS_STATE}</td>
                                                        <td>{item.ADDRESS_COUNTRY}</td>
                                                        <td>{item.POSITION_NAME}</td>
                                                        <td>{item.EMERGENCY_CONTACT}</td>
                                                        <td>{item.CONTACT_PHONE}</td>
                                                        <td>{item.MOBILE}</td>
                                                        <td>{item.SALARY_TYPE}</td>
                                                        <td>{item.RATE}</td>
                                                        <td>{item.PERSONAL_ID}</td>
                                                        {this.GetCustomListValue(item.USER_ID)}
                                                    </tr>;
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row">
                                    <div className="col-2 offset-10">
                                        <ClipLoader
                                            className={override}
                                            sizeUnit={"px"}
                                            size={30}
                                            color={'#33B5E5'}
                                            loading={this.state.loading}
                                        />
                                        <button disabled={this.state.AddButton} className="btn btn-info" onClick={(e) => { this.SaveEmployeeList(e) }} >Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>)
                }
            </div>
        );
    }
}

export default EmployeesImportFile;


// WEBPACK FOOTER //
// ./src/ImportFile/EmployeesImportfile.jsx